import { z } from 'zod';

/** Тело webhook ManyChat → CRM (External Request). */
export const ManyChatCrmInboundBody = z.object({
  manychatContactId: z.string().trim().min(1).max(64),
  instagramUsername: z.string().trim().max(64).optional(),
  instagramId: z.string().trim().max(64).optional(),
  displayName: z.string().trim().max(200).optional(),
  /** Slug города UpMe (напр. `tbilisi`). Неизвестный slug → 400. Без поля — `MANYCHAT_CRM_DEFAULT_CITY_SLUG`. */
  citySlug: z.string().trim().max(64).optional(),
  tagOrScenario: z.string().trim().max(200).optional(),
  messageText: z.string().trim().max(4000).optional(),
  /**
   * Опционально: уникальный ключ прогона automation в ManyChat (Custom Field / ручная сборка).
   * При повторе с тем же ключом inquiry не создаётся.
   */
  idempotencyKey: z.string().trim().min(1).max(128).optional(),
});
export type ManyChatCrmInboundBody = z.infer<typeof ManyChatCrmInboundBody>;

export const ManyChatCrmInboundResponse = z.object({
  ok: z.literal(true),
  contactId: z.uuid(),
  dealId: z.uuid(),
  created: z.boolean(),
});
export type ManyChatCrmInboundResponse = z.infer<typeof ManyChatCrmInboundResponse>;

export const CrmManyChatInquiryDto = z.object({
  id: z.uuid(),
  occurredAt: z.iso.datetime(),
  tagOrScenario: z.string().nullable(),
  messageText: z.string().nullable(),
  sourceLabel: z.string(),
});
export type CrmManyChatInquiryDto = z.infer<typeof CrmManyChatInquiryDto>;

export const CrmManyChatInquiriesDto = z.object({
  items: z.array(CrmManyChatInquiryDto).max(50),
});
export type CrmManyChatInquiriesDto = z.infer<typeof CrmManyChatInquiriesDto>;
